export default [
    {
        id: 1,
        title: "Netflix",
        coverImg: "netflix.webp",
        route: "netflix",

    },
    {
        id: 2,
        title: "Spotify",
        coverImg: "spotify.webp",
        route: "spotify",
    },
    {
        id: 3,
        title: "Amazon Prime",
        coverImg: "amazonprime.webp",
        route: "amazonprime",
    },
    {
        id: 4,
        title: "Soundcloud",
        coverImg: "soundcloud.webp",
        route: "soundcloud",
    },
]